import resistanceBand from './images/resistance-band.png';
import shakerBottle from './images/shaker-bottle.png';
import transformationBanner from './images/transformation-banner.png';

export const WELCOME_KIT_OFFER_ID = 'welcome_kit_annual_v1';

// `intro` is the post-loading intro screen's copy (Ethan's Sep 19 2026 mockup):
// a bold lead followed by the rest of the sentence.
export const WELCOME_KIT_ITEMS = [
  {
    id: 'resistance_band', name: 'Resistance Band', value: 29, image: resistanceBand,
    intro: { lead: 'Resistance band', rest: ' to power the warm-ups and mobility work in your program.' },
  },
  {
    id: 'shaker_bottle', name: 'Custom Shaker Bottle', value: 19, image: shakerBottle,
    intro: { lead: 'Custom shaker bottle', rest: ' that makes every gym session feel a little more official.' },
  },
  {
    id: 'transformation_banner', name: 'Transformation Banner', value: 9, image: transformationBanner,
    intro: { lead: 'Transformation banner', rest: " for taking progress photos you'll be proud to look back on." },
  },
] as const;

export const WELCOME_KIT_VALUE = WELCOME_KIT_ITEMS.reduce((total, item) => total + item.value, 0);

// Existing annual plans also have isMonthly=true because their displayed
// price is a monthly equivalent. The committed plan identifies annual billing.
export function isWelcomeKitPlan(plan?: { id: string; isOneTime?: boolean }): boolean {
  return plan?.id === 'committed' && !plan.isOneTime;
}
